package com.yendo.mx.ui.cart

import androidx.compose.animation.*
import androidx.compose.foundation.*
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.yendo.mx.ui.theme.RosaYendo
import com.yendo.mx.utils.formatPrecio

@Composable
fun OpcionesPagoEfectivo(total: Double, opcionSeleccionada: Double?, isDark: Boolean, onSeleccionar: (Double) -> Unit) {
    val opciones = remember(total) {
        val ops = mutableSetOf(total)
        val denominaciones = listOf(10.0, 20.0, 50.0, 100.0, 200.0, 500.0)
        denominaciones.forEach { denom ->
            val siguienteMultiplo = kotlin.math.ceil(total / denom) * denom
            if (siguienteMultiplo > total) ops.add(siguienteMultiplo)
            else {
                val residuoCentenas = total % 100.0
                if (residuoCentenas != 0.0 || denom >= 100.0) ops.add(total + denom)
            }
        }
        listOf(200.0, 500.0, 1000.0).forEach { billete -> if (billete > total) ops.add(billete) }
        ops.sorted().take(6)
    }

    val colorTexto = if (isDark) Color.White else Color.Black
    val colorSubTexto = if (isDark) Color.LightGray else Color.DarkGray

    Column(modifier = Modifier.fillMaxWidth()) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            Icon(Icons.Default.Payments, contentDescription = null, tint = RosaYendo, modifier = Modifier.size(28.dp))
            Spacer(Modifier.width(8.dp))
            Text("¿Con cuánto vas a pagar?", fontWeight = FontWeight.ExtraBold, fontSize = 18.sp, color = colorTexto)
        }
        Text("Necesario para llevarte tu cambio exacto.", color = colorSubTexto, fontSize = 13.sp, modifier = Modifier.padding(top = 4.dp))
        Spacer(Modifier.height(16.dp))
        LazyRow(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
            items(opciones) { monto ->
                val isSelected = opcionSeleccionada == monto
                Surface(
                    onClick = { onSeleccionar(monto) },
                    shape = RoundedCornerShape(12.dp),
                    color = if (isSelected) RosaYendo else if (isDark) Color(0xFF2C2C2E) else Color.White,
                    contentColor = if (isSelected) Color.White else colorTexto,
                    border = BorderStroke(1.dp, if (isSelected) RosaYendo else if (isDark) Color(0xFF3A3A3C) else Color(0xFFE0E0E0)),
                    shadowElevation = if (isSelected) 4.dp else 0.dp
                ) { Text(text = if (monto == total) "Exacto" else "$${monto.toInt()}", modifier = Modifier.padding(horizontal = 20.dp, vertical = 14.dp), fontWeight = FontWeight.Bold, fontSize = 15.sp) }
            }
        }
        AnimatedVisibility(visible = opcionSeleccionada != null && opcionSeleccionada > total) {
            Card(modifier = Modifier.fillMaxWidth().padding(top = 16.dp), colors = CardDefaults.cardColors(containerColor = Color(0xFFE8F5E9).copy(alpha = if(isDark) 0.1f else 1f)), border = BorderStroke(1.dp, Color(0xFF4CAF50)), shape = RoundedCornerShape(12.dp)) {
                Row(modifier = Modifier.padding(16.dp).fillMaxWidth(), verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.SpaceBetween) {
                    Column {
                        Text("El repartidor te entregará de cambio:", fontSize = 13.sp, color = Color(0xFF4CAF50), fontWeight = FontWeight.Bold)
                        Spacer(modifier = Modifier.height(4.dp))
                        Text(text = "$${formatPrecio((opcionSeleccionada ?: 0.0) - total)}", fontWeight = FontWeight.Black, fontSize = 28.sp, color = Color(0xFF4CAF50))
                    }
                    Icon(Icons.Default.MonetizationOn, contentDescription = null, tint = Color(0xFF4CAF50), modifier = Modifier.size(40.dp))
                }
            }
        }
    }
}

@Composable
fun ResumenFila(label: String, value: String, colorLabel: Color, colorValue: Color) {
    Row(modifier = Modifier.fillMaxWidth().padding(vertical = 4.dp), horizontalArrangement = Arrangement.SpaceBetween) {
        Text(label, color = colorLabel, fontSize = 14.sp); Text(value, color = colorValue, fontSize = 14.sp)
    }
}

@Composable
fun BotonSeleccion(texto: String, icono: ImageVector, seleccionado: Boolean, onClick: () -> Unit, modifier: Modifier = Modifier, isDark: Boolean) {
    val colorBg = if (seleccionado) RosaYendo.copy(alpha = 0.08f) else if (isDark) Color(0xFF1E1E1E) else Color.White
    val colorBorder = if (seleccionado) RosaYendo else if (isDark) Color(0xFF3A3A3C) else Color(0xFFE0E0E0)
    Surface(modifier = modifier.clickable { onClick() }, color = colorBg, shape = RoundedCornerShape(12.dp), border = BorderStroke(1.dp, colorBorder)) {
        Column(modifier = Modifier.padding(16.dp), horizontalAlignment = Alignment.CenterHorizontally) {
            Icon(icono, null, tint = if (seleccionado) RosaYendo else Color.Gray, modifier = Modifier.size(28.dp))
            Spacer(Modifier.height(8.dp))
            Text(texto, color = if (seleccionado) RosaYendo else Color.Gray, fontWeight = FontWeight.Bold, fontSize = 13.sp)
        }
    }
}

@Composable
fun ChipSeleccion(texto: String, seleccionado: Boolean, isDark: Boolean, onClick: () -> Unit) {
    val colorUnselected = if (isDark) Color(0xFF2C2C2E) else Color(0xFFF5F5F5)
    val colorTextUnselected = if (isDark) Color.LightGray else Color.DarkGray
    Surface(modifier = Modifier.clickable { onClick() }, color = if (seleccionado) RosaYendo else colorUnselected, shape = RoundedCornerShape(20.dp)) {
        Text(text = texto, modifier = Modifier.padding(horizontal = 16.dp, vertical = 8.dp), color = if (seleccionado) Color.White else colorTextUnselected, fontWeight = FontWeight.Bold, fontSize = 13.sp)
    }
}

@Composable
fun MetodoPagoItem(titulo: String, icono: ImageVector, seleccionado: Boolean, modifier: Modifier = Modifier, isDark: Boolean, onSelect: () -> Unit) {
    val colorBg = if (seleccionado) RosaYendo.copy(alpha = 0.08f) else if (isDark) Color(0xFF1E1E1E) else Color.White
    val colorBorder = if (seleccionado) RosaYendo else if (isDark) Color(0xFF3A3A3C) else Color(0xFFEEEEEE)
    Card(modifier = modifier.clickable { onSelect() }, colors = CardDefaults.cardColors(containerColor = colorBg), border = BorderStroke(if (seleccionado) 2.dp else 1.dp, colorBorder)) {
        Column(modifier = Modifier.padding(16.dp).fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally) {
            Icon(icono, null, tint = if (seleccionado) RosaYendo else Color.Gray)
            Spacer(Modifier.height(8.dp))
            Text(titulo, fontWeight = FontWeight.Bold, color = if (seleccionado) RosaYendo else Color.Gray, fontSize = 12.sp)
        }
    }
}
